var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Frame',{attrs:{"width":3840,"height":2160,"bgColor":""}},[_c('div',{attrs:{"id":"page-body"}},[_c('topHeader',{attrs:{"anjie":_vm.anjie},on:{"reload":_vm.change}}),_c('div',{staticClass:"container"},[_c('myLeft',{ref:"myLeft",attrs:{"moneyRank":_vm.moneyRank,"anjie":_vm.anjie}}),_c('myBottom',{ref:"myBottom"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }